import { trackClick } from '@hotjar/webapp/features/Playbacks/utils/tracking';

/**
 * Triggered when user clicks the `Create a Poll` button on
 * Poll upsell of the `poll_awareness_in_recordings` experiment.
 * We track the click event and navigate user to Poll creation page.
 */
import { Store } from '../../../store/player/types';

export const goToPollCreatePage = (store: Store): void => {
  const { siteId, recording } = store.getState();
  if (!recording) return;

  trackClick(recording, {
    element_name: 'Create Poll button',
    ui_position: 'Poll upsell in Recordings',
  });

  window.open(`/sites/${siteId}/polls/create/`, '_blank');
};
